import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as authenticationActions from './state/authentication.actions';
import { State } from '@wam/shared';

@Component({
  selector: 'signup',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class SignupComponent implements OnInit {
  private store = inject<Store<State>>(Store);

  ngOnInit(): void {
    this.store.dispatch(authenticationActions.signUp());
  }
}
